import {TRAINING_FACULTY, TRAINING_TYPE} from "../tagTypes";

export function hasTrainingSnapshot(snapshot) {
  return Array.isArray(snapshot) && snapshot.length > 0;
}

export function getSavedFacultyId(snapshot) {
  if (!hasTrainingSnapshot(snapshot)) {
    return null;
  }

  const faculty = snapshot.find((item) => item?.typeTitle === TRAINING_FACULTY);
  return faculty?.value?.id ?? null;
}

export function getSavedTrainingType(snapshot) {
  if (!hasTrainingSnapshot(snapshot)) {
    return '';
  }

  const typeTraining = snapshot.find((item) => item?.typeTitle === TRAINING_TYPE);
  return typeTraining?.value?.value || '';
}

export function canHydrateByType(snapshot, selectedType) {
  if (!selectedType) {
    return false;
  }

  const savedType = getSavedTrainingType(snapshot);
  return Boolean(savedType) && savedType === selectedType;
}
